module.exports = __webpack_public_path__ + "img/network.104417e8.png";